import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../styles/styles.css';
import { getCompanyById, patchCompanyById } from '../services/api';
import { toast } from 'react-toastify';
import {formatRut} from '../utils/rut';


const EditarEmpresa = () => {
  const { empresaId } = useParams();
  const [empresa, setEmpresa] = useState({
    nombre_legal: '',
    email: '',
    password: '',
    rut: '',
    ciudad: '',
    giro: '',
    razon_social: '',
    rubro: '',
    direccion: '',
    forma_pago: 'factura',
    dias_pago: '',
  });
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Obtener datos existentes de la empresa para editar
    const fetchEmpresa = async () => {
      try {
        const { data } = await getCompanyById(empresaId); // api.js
        setEmpresa({
          nombre_legal: data.nombre_legal || '',
          email: data.email || '',
          password: '',
          rut: data.rut ? formatRut(data.rut) : '',
          ciudad: data.ciudad || '',
          giro: data.giro || '',
          razon_social: data.razon_social || '',
          rubro: data.rubro || '',
          direccion: data.direccion || '',
          forma_pago: data.forma_pago || '',
          dias_pago: data.dias_pago !== null && data.dias_pago !== undefined ? String(data.dias_pago) : '',
        });
      } catch (error) {
        console.error('Error al obtener datos de la empresa:', error);
        setError('No se pudo cargar la empresa.');
      }
    };

    fetchEmpresa();
  }, [empresaId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    let formattedValue = value;
    if (name === 'rut') {
      formattedValue = formatRut(value);
    }else if (name === 'dias_pago'){
      formattedValue = value.replace(/[^0-9]/g, "");
    }

    setEmpresa((prevEmpresa) => ({
      ...prevEmpresa,
      [name]: formattedValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...empresa };
      
      if (payload.rut) {
        payload.rut = payload.rut.replace(/[^0-9kK]/g, '').toUpperCase();
      }
      // Si la contraseña está vacía, no la enviamos
      if (!payload.password || payload.password.trim() === '') {
        delete payload.password;
      }
      
      if (payload.dias_pago && payload.dias_pago !== "") {
        payload.dias_pago = parseInt(payload.dias_pago, 10);
      } else {
        payload.dias_pago = null;
      }
      
      Object.keys(payload).forEach(key => {
        if(payload[key]===""){
          payload[key] = null;
        }
      });

      await patchCompanyById(empresaId, payload); // api.js
      toast.success('Empresa actualizada exitosamente');
      navigate('/empresas');
    } catch (error) {
      console.error('Error al actualizar la empresa:', error);

      if (error.response?.status === 409) {
        // Conflicto de unicidad
        const details = error.response?.data?.details;
        if (details) {
          const msgs = Object.entries(details).map(([field, msg]) => `${field}: ${msg}`);
          toast.error(<div>Conflicto de unicidad:{msgs.map((m, i) => <div key={i}>{m}</div>)}</div>);
        } else {
          toast.error("Conflicto: datos duplicados (email o RUT).");
        }
      } else if (error.response?.status === 422) {
        // Errores de validación de Marshmallow
        const validationErrors = error.response?.data?.errors?.json || error.response?.data?.details;
        if (validationErrors) {
          const msgs = Object.entries(validationErrors).map(([field, errs]) => {
            const label = field === 'rut' ? 'RUT' : field;
            const errorMessage = Array.isArray(errs) ? errs.join(', ') : errs;
            return `${label}: ${errorMessage}`;
          });
          toast.error(<div>Errores de validación:{msgs.map((m, i) => <div key={i}>{m}</div>)}</div>);
        } else {
          toast.error("Error de validación en los datos.");
        }
      } else {
        toast.error("Error inesperado al actualizar la empresa.");
      }
    }
  };

  if (error) return <p className="required-text">{error}</p>;

  return (
    <div className="container">
      <h1>Editar Empresa</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Nombre</label>
          <input
            type="text"
            name="nombre_legal"
            className="form-control"
            value={empresa.nombre_legal}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={empresa.email}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group">
          <label>Contraseña (dejar en blanco para no cambiar)</label>
          <input
            type="password"
            name="password"
            className="form-control"
            value={empresa.password}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group">
          <label>RUT</label>
          <input
            type="text"
            name="rut"
            className="form-control"
            value={empresa.rut}
            onChange={handleInputChange}
            placeholder="EJ: 76.123.456-K"
            maxLength="12"
          />
        </div>
        <div className="form-group">
          <label>Ciudad</label>
          <input
            type="text"
            name="ciudad"
            className="form-control"
            value={empresa.ciudad}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group">
          <label>Giro</label>
          <input
            type="text"
            name="giro"
            className="form-control"
            value={empresa.giro}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group">
          <label>Razón Social</label>
          <input
            type="text"
            name="razon_social"
            className="form-control"
            value={empresa.razon_social}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group">
          <label>Rubro</label>
          <input
            type="text"
            name="rubro"
            className="form-control"
            value={empresa.rubro}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group">
          <label>Dirección</label>
          <input
            type="text"
            name="direccion"
            className="form-control"
            value={empresa.direccion}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group">
          <label>Forma de Pago</label>
          <select
            name="forma_pago"
            className="form-control"
            value={empresa.forma_pago}
            onChange={handleInputChange}
          >
            <option value="factura">Factura</option>
            <option value="boleta">Boleta</option>
          </select>
        </div>
        <div className="form-group">
          <label>Días de Pago</label>
          <input
            type="text"
            name="dias_pago"
            className="form-control"
            value={empresa.dias_pago}
            onChange={handleInputChange}
            inputMode="numeric"
          />
        </div>
        <br />
        <div className="form-group">
          <button type="submit" className="btn btn-create">
            Guardar Cambios
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditarEmpresa;
